/**
 * Enum for the animation key frame interpolation type
 */
export var AnimationKeyInterpolation;
(function (AnimationKeyInterpolation) {
    /**
     * Do not interpolate between keys and use the start key value only. Tangents are ignored
     */
    AnimationKeyInterpolation[AnimationKeyInterpolation["STEP"] = 1] = "STEP";
})(AnimationKeyInterpolation || (AnimationKeyInterpolation = {}));
//# sourceMappingURL=animationKey.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babylonjs/core/Animations/animationKey.js
// module id = cNBs
// module chunks = 0